<pc-navigation></pc-navigation>
<router-outlet />
<pc-footer></pc-footer>